import React from 'react';
import PropTypes from 'prop-types';

export default class DatePicker extends React.Component {
  render() {
    const props = this.props;
    return <input ref="input" type="date" {...props}
    />
  }
}

DatePicker.propTypes = {
  onSetDate: PropTypes.func.isRequired
}